/* PlansPricing.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { media } from '@atlaskit/primitives';
import { FluidContainer } from '@atlassian/mpac-primitives';
import { PlansEditionDetailsCard, PlansFeatureComparisonTable, PlansUserInputSection, PlansViewPricingLink } from '@atlassian/mpac-ui';
import { editionConstants } from '@atlassian/mpac-utils';
import { useRef } from 'react';
import { PAID_APP_CTA_LABEL_START_TRIAL } from '../../../../../../constants';
import { PricingHeading } from '../PricingTab.styles';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _16 = "._19pkxncg{margin-top:var(--ds-space-800,4pc)}";
const _15 = "@media not all and (min-width:64rem){._o5kc1y6m{justify-content:flex-start}}";
const _14 = "._1fjgglyw{scrollbar-width:none}";
const _13 = "._1reo1wug{overflow-x:auto}";
const _12 = "._zulpxy5q{gap:var(--ds-space-400,2pc)}";
const _11 = "@media not all and (min-width:64rem){._2osnxy5q{gap:var(--ds-space-400,2pc)}._159e1wug{align-self:auto}}";
const _10 = "._1wpz1h6o{align-self:center}";
const _9 = "._p12f1d56{max-width:48rem}";
const _8 = "._zulp1ejb{gap:var(--ds-space-300,24px)}";
const _7 = "@media not all and (min-width:64rem){._tl28idpf{padding-top:0}._axwiidpf{padding-right:0}._1hwcidpf{padding-bottom:0}._sp8tidpf{padding-left:0}._2osnxy5q{gap:var(--ds-space-400,2pc)}}";
const _6 = "._ca0qu2gc{padding-top:var(--ds-space-100,8px)}";
const _5 = "._2lx21bp4{flex-direction:column}";
const _4 = "._1e0c1txw{display:flex}";
const _3 = "._zulpoahv{gap:var(--ds-space-600,3pc)}";
const _2 = "@media not all and (min-width:64rem){._3wvkidpf{margin-top:0}._1fbnidpf{margin-right:0}._1ubyidpf{margin-bottom:0}._1t0ridpf{margin-left:0}}";
const _ = "._ca0qxy5q{padding-top:var(--ds-space-400,2pc)}";
const {
  TEST_IDS
} = editionConstants;
const {
  FEATURE_COMPARISON_TITLE
} = TEST_IDS;
const fluidContainerStyle = null;
const editionDetailsSection = null;
const editionDetailsContainer = null;
const editionCardContainer = null;
const featureDetailsSection = null;
export const PlansPricing = _ref => {
  let {
    editions,
    teamSize,
    onTeamSizeChange,
    onBillingFrequencyChange,
    billingFrequency,
    lastTierCeiling,
    handleStartFreeTrialClick
  } = _ref;
  const compareFeaturesRef = useRef(null);
  const focusFeatureTable = () => {
    if (compareFeaturesRef.current) {
      compareFeaturesRef.current.focus();
    }
  };
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2]
    }), /*#__PURE__*/_jsxs(FluidContainer, {
      className: ax(["_ca0qxy5q _3wvkidpf _1fbnidpf _1ubyidpf _1t0ridpf"]),
      children: [/*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_3, _4, _5, _6, _7]
        }), /*#__PURE__*/_jsxs("section", {
          className: ax(["_zulpoahv _1e0c1txw _2lx21bp4 _ca0qu2gc _tl28idpf _axwiidpf _1hwcidpf _sp8tidpf _2osnxy5q"]),
          children: [/*#__PURE__*/_jsx(PricingHeading, {
            as: "h2",
            children: "Simple, transparent pricing for your team"
          }), /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_8, _4, _5, _9, _10, _11]
            }), /*#__PURE__*/_jsxs("div", {
              className: ax(["_zulp1ejb _1e0c1txw _2lx21bp4 _p12f1d56 _1wpz1h6o _2osnxy5q _159e1wug"]),
              children: [/*#__PURE__*/_jsx(PlansUserInputSection, {
                teamSize: teamSize,
                onTeamSizeChange: onTeamSizeChange,
                onBillingFrequencyChange: onBillingFrequencyChange,
                billingFrequency: billingFrequency
              }), /*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_12, _4, _13, _14, _15]
                }), /*#__PURE__*/_jsx("div", {
                  "data-testid": "plans-edition-details-cards",
                  className: ax(["_zulpxy5q _1e0c1txw _1reo1wug _1fjgglyw _o5kc1y6m"]),
                  children: editions === null || editions === void 0 ? void 0 : editions.map(item => /*#__PURE__*/_jsx(PlansEditionDetailsCard, {
                    editionDetails: item,
                    billingFrequency: billingFrequency,
                    teamSize: teamSize,
                    lastTierCeiling: lastTierCeiling,
                    source: "pricingTab",
                    onMoreFeaturesClick: focusFeatureTable,
                    startFreeTrialLabel: PAID_APP_CTA_LABEL_START_TRIAL,
                    handleStartFreeTrialClick: handleStartFreeTrialClick
                  }, item.type))
                })]
              }), /*#__PURE__*/_jsx(PlansViewPricingLink, {
                editions: editions,
                billingFrequency: billingFrequency
              })]
            })]
          })]
        })]
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_12, _4, _5, _16]
        }), /*#__PURE__*/_jsxs("section", {
          className: ax(["_zulpxy5q _1e0c1txw _2lx21bp4 _19pkxncg"]),
          children: [/*#__PURE__*/_jsx(PricingHeading, {
            as: "h2",
            ref: compareFeaturesRef,
            tabIndex: -1,
            "data-testId": FEATURE_COMPARISON_TITLE,
            children: "Compare features"
          }), /*#__PURE__*/_jsx(PlansFeatureComparisonTable, {
            editionFeatures: editions.map(_ref2 => {
              let {
                id,
                type,
                features
              } = _ref2;
              return {
                id,
                type,
                features
              };
            })
          })]
        })]
      })]
    })]
  });
};